export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14921.08b6e7d9.jpg";